/*
 * Note: Do not add non-optional logic to this class. CDN/bundle users of this library are not able to
 * extend this class and must define their own base action class to extend from. Any new required logic
 * added here would also need to be added to CDN users' custom base action class.
 */
export class Action {
    constructor(props) {
        this.data = props; // Casting to D is safe and intentional
    }
}
//# sourceMappingURL=Action.js.map